import { render, staticRenderFns } from "./personAfil.vue?vue&type=template&id=15090b40&scoped=true&"
import script from "./personAfil.vue?vue&type=script&lang=js&"
export * from "./personAfil.vue?vue&type=script&lang=js&"
import style0 from "./personAfil.vue?vue&type=style&index=0&id=15090b40&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15090b40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15090b40')) {
      api.createRecord('15090b40', component.options)
    } else {
      api.reload('15090b40', component.options)
    }
    module.hot.accept("./personAfil.vue?vue&type=template&id=15090b40&scoped=true&", function () {
      api.rerender('15090b40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/person-afil/personAfil.vue"
export default component.exports